export default "<ng-container>\r\n    <agendamento-webcomponent #agendamentoWebComponent></agendamento-webcomponent>\r\n</ng-container>"